import { Route, Routes } from 'react-router-dom';
import Home from './Home';

function Router() {
  return (
    <Routes>
      <Route exact path="/prna/home" element={<Home />} />
    </Routes>
  );
}

export default Router;
